import type { PostHog } from "posthog-js";

type UserData = {
	id: string;
	email: string;
	username?: string | null;
	displayName?: string | null;
	rawID: string;
};

export function identifyUser(posthog: PostHog, user: UserData) {
	posthog.identify(user.rawID, {
		email: user.email,
		username: user.username,
		display_name: user.displayName,
	});
}

export function trackSignup(posthog: PostHog, user: UserData) {
	identifyUser(posthog, user);
	posthog.capture("auth_signup_completed", {
		method: "email",
	});
}

export function trackLogin(posthog: PostHog, user: UserData) {
	identifyUser(posthog, user);
	posthog.capture("auth_login_completed", {
		method: "email",
	});
}
